// Private Check-In — 8 questions.
// This is a snapshot, not a score, diagnosis, category, or ranking.

export const QUIZ_QUESTIONS = [
  {
    id: "q1",
    prompt: "How safe do you feel naming what's hurting right now?",
    helper: "There's no wrong answer. Just notice.",
  },
  {
    id: "q2",
    prompt:
      "How often do you reach for something to get distance from what you are feeling (substances, scrolling, food, work, intimacy)?",
    helper: "You can notice a pattern without judging it.",
  },
  {
    id: "q3",
    prompt: "How clearly can you notice your patterns right now?",
    helper: "You do not have to explain or judge them to notice them.",
  },
  {
    id: "q4",
    prompt: "How connected do you feel to people who truly know you?",
    helper: "Even one person can matter.",
  },
  {
    id: "q5",
    prompt: "When difficult feelings arise, how present can you stay with them?",
    helper: "Staying can simply mean noticing, not fixing.",
  },
  {
    id: "q6",
    prompt: "How at ease do you feel with the choices or patterns you have noticed lately?",
    helper: "Whatever you notice does not define you.",
  },
  {
    id: "q7",
    prompt: "How clear are you about what you need right now?",
    helper: "Clarity can unfold. You do not have to know it all today.",
  },
  {
    id: "q8",
    prompt: "How much hope can you locate right now?",
    helper: "Hope can be quiet, uncertain, or hard to find.",
  },
];

export const QUIZ_OPTIONS = [
  { value: 1, label: "Not at all" },
  { value: 2, label: "A little" },
  { value: 3, label: "Somewhat" },
  { value: 4, label: "A lot" },
  { value: "prefer_not", label: "Prefer not to answer" },
];

export const answerLabel = (value) =>
  QUIZ_OPTIONS.find((option) => option.value === value)?.label || "Not answered";

export const buildCheckInSnapshot = (answers = {}) => ({
  kind: "snapshot",
  answers: { ...answers },
});
